// extracted by mini-css-extract-plugin
export var closeButton = "_fc-1";
export var closeX = "_fc-3";
export var container = "_fc-0";
export var image = "_fc-2";